import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces'

export function useExperimentSelector() {
    const experiment = useSelector((state: StateExtended) => state.experiment?.experiment)
    return experiment
}
